module.exports = __webpack_public_path__ + "img/canva_for_beginners_splash.0a542157.jpg";